import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem } from "../../../../types";
import { WSQueryCache } from "@ws-react-query";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";
import { QUERY_IDENTITY_VERIFICATION_REQUEST } from "../../../../../../query/identityVerification/keys";

export const getIdentityVerificationRequestFromCache = (
  requirement: IRequirementResponse,
  contextItem: ContextItem
): IIdentityVerificationRequestResponse | undefined => {
  return WSQueryCache.getQueryData<IIdentityVerificationRequestResponse>([
    QUERY_IDENTITY_VERIFICATION_REQUEST,
    requirement.dataSourceId
  ]);
};
